import React from "react";
import { IOrganizationUserTrainingCourseSummary } from "src/@types/ImpiricaPlatformApi";
import TrainingSummaryHeaderCourse from "./TrainingSummaryHeaderCourse";
import styles from "./TrainingSummaryHeader.module.scss";
type TrainingSummaryHeaderProps = {
	courses: IOrganizationUserTrainingCourseSummary[];
	name: string;
};

const TrainingSummaryHeader: React.FC<TrainingSummaryHeaderProps> = ({
	courses,
	name,
}) => {
	return (
		<div className={styles.container}>
			<p className={styles.name}>{name}</p>
			{courses &&
				courses.map((course) => (
					<TrainingSummaryHeaderCourse key={course.title} {...course} />
				))}
		</div>
	);
};

export default TrainingSummaryHeader;
